/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { challengeIssueStatusSchema, type IChallengeIssueStatus } from '../enums';

const reportDataSchema = z.object({
  issueId: z.number(),
  status: challengeIssueStatusSchema,
  remediated: z.boolean(),
});

export interface IReportChallengeIssueData {
  issueId: number;
  status: IChallengeIssueStatus;
  remediated: boolean;
}

export const reportChallengeIssueResponseSchema = createApiResponseSchema(
  reportDataSchema,
) as z.ZodSchema<IAPI<IReportChallengeIssueData>>;

export type IReportChallengeIssueResponse = IAPI<IReportChallengeIssueData>;
